import { isValidElement, useCallback, useEffect, useReducer, useRef } from "react";
import { createReducer } from "../store/createReducer.js";
import { initializer } from "../store/initializer.js";
function serializeSchema(schema) {
  return JSON.stringify(schema, (_key, value) => {
    if (isValidElement(value)) {
      return void 0;
    }
    return value;
  });
}
function useControlsActions(initialState) {
  const [{ schema, values }, dispatch] = useReducer(createReducer(), initialState, initializer);
  const rInitialState = useRef(initialState);
  useEffect(() => {
    const changedValue = serializeSchema(rInitialState.current) !== serializeSchema(initialState);
    rInitialState.current = initialState;
    if (!changedValue) return;
    dispatch({ schema: initialState, type: "updateSchema" });
  }, [initialState]);
  return {
    resetFields: useCallback(() => {
      dispatch({
        type: "resetFields"
      });
    }, []),
    schema,
    setField: useCallback((key, value) => {
      dispatch({
        key,
        type: "setField",
        value
      });
    }, []),
    updateSchema: useCallback((schema2) => {
      dispatch({
        schema: schema2,
        type: "updateSchema"
      });
    }, []),
    values
  };
}
export {
  useControlsActions
};
//# sourceMappingURL=useControlsActions.js.map
